<script setup>
import { ref } from 'vue'

const icons = ref([
    {
        id: 1,
        text: 'Объединение и развитие плодотворного сотрудничества отечественных ученых и специалистов'
    },
    {
        id: 2,
        text: 'Анализ состояния, обсуждение проблем и путей решения, систематизация результатов'
    },
    {
        id: 3,
        text: 'Мониторинг тенденций и определение перспектив развития теории, прикладных исследований и разработок'
    },
    {
        id: 4,
        text: 'Развитие международного сотрудничества в области искусственного интеллекта'
    },
    {
        id: 5,
        text: 'Популяризация знаний в области искусственного интеллекта'
    },
    {
        id: 6,
        text: 'Содействие в профессиональной деятельности членов РАИИ'
    },
    {
        id: 7,
        text: 'Поддержка и продвижение отечественных теоретических и прикладных исследований и разработок'
    },
    {
        id: 8,
        text: 'Независимая профессиональная экспертиза проектов и результатов теоретических и прикладных исследований и разработок'
    },
    {
        id: 9,
        text: 'Консультативная и экспертная поддержка, участие в разработке отечественных и международных нормативных документов по тематике искусственного интеллекта (по запросам или проактивно) для органов государственной власти, бизнеса, других интитутов и организаций'
    }
])
</script>

<template>
    <h1 class="title">РОССИЙСКАЯ АССОЦИАЦИЯ ИСКУССТВЕННОГО ИНТЕЛЛЕКТА</h1>
    <p class="main-text">
        Всероссийская творческая профессиональная организация - создана на
        основе Советской ассоциации искусственного интеллекта и зарегистрирована
        Минюстом РФ 19.10.92 N 1304. Ассоциация объединяет в своих рядах ученых
        России и многих ученых из стран СНГ, областью профессиональной
        деятельности которых является искусственный интеллект.
    </p>
    <h1 class="title">ОСНОВНЫЕ ЦЕЛИ РАИИ</h1>
    <v-row class="ml-n2 mr-n2 icons">
        <v-col
            v-for="icon in icons"
            :key="icon.id"
            class="pl-2 pr-2 pt-8"
            cols="12"
            sm="6"
            md="4"
        >
            <img
                :src="`/svg/about-page/icon${icon.id}.svg`"
                alt="Иконка"
            />
            <p class="icon-text">
                {{ icon.text }}
            </p>
        </v-col>
    </v-row>
</template>

<style lang="scss" scoped>
.title {
    font-size: 36px;
    font-weight: 600;
    line-height: 40px;
    color: #0635ac;

    @media screen and (max-width: 767px) {
        font-size: 28px;
        line-height: 36px;
    }
}

.main-text {
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    text-align: center;
    margin-top: 15px;
    margin-bottom: 30px;
}

.icons {
    margin-top: 16px;
}

.icon-text {
    font-size: 17px;
    font-weight: 400;
    line-height: 25px;
    margin-top: 24px;
}
</style>
